
import type { InputHTMLAttributes, } from 'vue/types/jsx';
import { Component, Model, Prop, Ref, Vue, Watch, } from 'vue-property-decorator';
import { debounce, } from '~/utils/debounce';

@Component({
	inheritAttrs: false,
})
export default class PasswordInput extends Vue {

	@Prop({
		type: String,
		required: false,
		default: 'password',
	})
	id!: string;

	@Prop({
		type: String,
		required: false,
		default: 'password',
	})
	name!: string;

	@Prop({
		type: Boolean,
		required: false,
		default: false,
	})
	isValid!: boolean;

	@Prop({
		type: Boolean,
		required: false,
		default: false,
	})
	isInvalid!: boolean;

	@Ref('passwordInput')
	passwordInput!: HTMLInputElement;

	@Model('input', {
		type: String,
	})
	readonly passwordValue!: string;

	@Prop({
		type: String,
		required: false,
	})
	autocomplete?: InputHTMLAttributes['autocomplete'];

	@Watch('hasAnyFocus')
	onHasAnyFocusChanged = debounce((val: boolean, oldVal: boolean) => {
		if (val === oldVal) {
			return;
		}

		if (val) {
			this.passwordChanged = false;
			this.$emit('focus');
		} else {
			if (this.passwordChanged) {
				this.$emit('change');
			}
			this.$emit('blur');
		}
	}, 10);

	passwordVisible = false;
	passwordChanged = false;

	togglePasswordVisibility() {
		this.passwordVisible = !this.passwordVisible;
		this.passwordInput.focus({ preventScroll: false, });
	}

	inputFocus = false;
	buttonFocus = false;

	get hasAnyFocus() {
		return this.inputFocus || this.buttonFocus;
	}

	onInputChange() {
		this.passwordChanged = true;
	}

	onInput($event: Event) {
		this.$emit('input', ($event.target as HTMLInputElement)?.value);
	}

	onInputBlur() {
		this.inputFocus = false;
	}

	onInputFocus() {
		this.inputFocus = true;
	}

	onButtonBlur() {
		this.buttonFocus = false;
	}

	onButtonFocus() {
		this.buttonFocus = true;
	}
}
